
module.exports = function getResource(label, vars = []) {
    let resources = {
        shopFaves: 'Dénichez parmi vos favoris',
        viewAll: 'Tout afficher',
        fromLovesList: 'De votre liste de favoris...'
    };
    return resources[label];
};
